export default "__VITE_ASSET__C_MVnuw2__"